import { FC, PropsWithChildren, useEffect, useState } from 'react';

import { toggleArrayObject } from '@/helpers/toggleArrayItem';
import { ACTIVITY_CART } from '@/utils/constans';

import ActivityCartContext, { ActivityCartItem } from './ActivityCartContext';

const ActivityCartContextProvider: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { Provider } = ActivityCartContext;

  const [activityCart, setActivityCart] = useState<Array<ActivityCartItem>>([]);

  useEffect(() => {
    const defaultValue = localStorage.getItem(ACTIVITY_CART);

    if (defaultValue) {
      try {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setActivityCart(JSON.parse(defaultValue) as Array<ActivityCartItem>);
      } catch {
        setActivityCart([]);
      }
    }
  }, []);

  function toggleActivityCartItem(activityCartItem: ActivityCartItem) {
    const newCartItems = toggleArrayObject(
      activityCartItem,
      'id',
      activityCart
    );
    setActivityCart(newCartItems);
    localStorage.setItem(ACTIVITY_CART, JSON.stringify(newCartItems));
  }

  function onReset() {
    setActivityCart([]);
    localStorage.removeItem(ACTIVITY_CART);
  }

  return (
    <Provider
      value={{
        activityCart,
        toggleActivityCartItem,
        onReset,
      }}
    >
      {children}
    </Provider>
  );
};

export default ActivityCartContextProvider;
